import { Formik, Form, Field, ErrorMessage } from "formik";
import { useEffect, useState, useContext } from "react";
import * as Yup from "yup";
import { Select, Spin, Timeline } from 'antd';
import FormError from "../../common/FormError";
import { EditableContext } from "../../common/EditableContextProvider";
import { CheckCircleOutlined } from '@ant-design/icons';

export const FormComponent = () => {
    const { casos, pasos } = useContext(EditableContext);
    const [initialValues, setInitialvalues] = useState(casos.editItem);

    useEffect(() => {
        setInitialvalues(casos.editItem);
    }, [casos.editItem]);

    const handleSubmit = async (values, formik) => {
        await casos.handle_save(values);
    }

    const validateSchema = Yup.object({
        codigo: Yup.string()
            .min(3, 'El texto debe tener al menos 3 letras.')
            .max(200, 'El texto es demasiado largo')
            .nullable(),
        fecha_inicio: Yup.date()
            .required('El campo es obligario.'),
        cliente_id: Yup.number()
            .required('El campo es obligario.'),
        abogado_titular_id: Yup.number()
            .required('El campo es obligario.'),
        abogado_junior_id: Yup.number()
            .required('El campo es obligario.'),
        area_id: Yup.number()
            .required('El campo es obligario.'),
        tramite_id: Yup.number()
            .required('El campo es obligario.'),
        monto_adeudado_tramites: Yup.number()
            .required('El campo es obligario.'),
        monto_adeudado_honorarios: Yup.number()
            .required('El campo es obligario.'),
        monto_cancelado: Yup.number()
            .required('El campo es obligario.'),
    });

    return (
        <div>
            <div className="row">
                <div className="col-md">
                    <Formik
                        initialValues={initialValues}
                        onSubmit={handleSubmit}
                        validationSchema={validateSchema}
                        enableReinitialize={true}
                    >
                        {
                            (formik) => (
                                <Form>
                                    <div className="py-1">
                                        <span>ID: </span>
                                        <span className="fw-bold ms-1">{sprintf('%04d', casos.editItem.id)}</span>
                                    </div>

                                    <div className="mb-2">
                                        <label htmlFor="codigo" className="form-label">
                                            Código Caso
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <input id="codigo" name="codigo" type="text" className="form-control form-control-sm"
                                            value={formik.values.codigo ?? ""}
                                            onChange={(e) => formik.setFieldValue('codigo', e.target.value)}
                                        />
                                        <ErrorMessage name="codigo" component={FormError} />
                                    </div>

                                    <div className="row mb-2">
                                        <div className="col">
                                            <label htmlFor="fecha_inicio" className="form-label">
                                                Fecha inicio
                                                <span className="text-danger">(*)</span>
                                            </label>
                                            <input type="date" id="fecha_inicio" className="form-control form-control-sm"
                                                value={formik.values.fecha_inicio}
                                                onChange={(e) => formik.setFieldValue('fecha_inicio', e.target.value)}
                                            />
                                            <ErrorMessage name="fecha_inicio" component={FormError} />
                                        </div>
                                        <div className="col">
                                            <label htmlFor="fecha_fin" className="form-label">
                                                Fecha finalización
                                            </label>
                                            <input type="date" id="fecha_fin" className="form-control form-control-sm"
                                                value={formik.values.fecha_fin ?? ""}
                                                onChange={(e) => formik.setFieldValue('fecha_fin', e.target.value)}
                                            />
                                            <ErrorMessage name="fecha_fin" component={FormError} />
                                        </div>
                                    </div>

                                    <div className="mb-2">
                                        <label htmlFor="Cliente" className="form-label">
                                            Cliente
                                            <span className="text-danger">(*)</span>
                                        </label>

                                        <Select
                                            className="w-100"
                                            showSearch
                                            placeholder="Seleccionar"
                                            filterOption={(input, option) => ((option?.label ?? '').toLowerCase().includes(input.toLowerCase()))}
                                            options={casos.resources.clientes.map(cl => ({ label: `${cl.nombres} ${cl.apellidos}`, value: cl.id }))}
                                            value={formik.values.cliente_id}
                                            onChange={(value) => formik.setFieldValue('cliente_id', value)}
                                        ></Select>

                                        <ErrorMessage name="cliente_id" component={FormError} />
                                    </div>

                                    <div className="mb-2">
                                        <label htmlFor="titular" className="form-label">
                                            Abogado Titular
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <Select
                                            className="w-100"
                                            showSearch
                                            placeholder="Seleccionar"
                                            filterOption={(input, option) => ((option?.label ?? '').toLowerCase().includes(input.toLowerCase()))}
                                            options={casos.resources.titulares.map(t => ({ label: `${t.nombres} ${t.apellidos}`, value: t.id }))}
                                            value={formik.values.abogado_titular_id}
                                            onChange={(value) => {
                                                formik.setFieldValue('abogado_titular_id', value);
                                                formik.setFieldValue('abogado_junior_id', "");
                                            }}
                                        ></Select>
                                        <ErrorMessage name="abogado_titular_id" component={FormError} />
                                    </div>

                                    <div className="mb-2">
                                        <label htmlFor="titular" className="form-label">
                                            Abogado Junior
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <Select
                                            className="w-100"
                                            showSearch
                                            placeholder="Seleccionar"
                                            filterOption={(input, option) => ((option?.label ?? '').toLowerCase().includes(input.toLowerCase()))}
                                            options={
                                                casos.resources.juniors
                                                    .filter(j => j.titular.id === formik.values.abogado_titular_id)
                                                    .map(t => ({ label: `${t.nombres} ${t.apellidos}`, value: t.id }))
                                            }
                                            value={formik.values.abogado_junior_id}
                                            onChange={(value) => formik.setFieldValue('abogado_junior_id', value)}
                                        ></Select>
                                        <ErrorMessage name="abogado_junior_id" component={FormError} />
                                    </div>

                                    <div className="mb-2">
                                        <label htmlFor="area" className="form-label">
                                            Area
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <Select
                                            className="w-100"
                                            showSearch
                                            placeholder="Seleccionar"
                                            filterOption={(input, option) => ((option?.label ?? '').toLowerCase().includes(input.toLowerCase()))}
                                            options={casos.resources.areas.map(t => ({ label: `${t.nombre}`, value: t.id }))}
                                            value={formik.values.area_id}
                                            onChange={(value) => {
                                                formik.setFieldValue('area_id', value);
                                                formik.setFieldValue('tramite_id', '');
                                            }}
                                        ></Select>
                                        <ErrorMessage name="area_id" component={FormError} />
                                    </div>

                                    <div className="mb-2">
                                        <label htmlFor="tramite" className="form-label">
                                            Trámite
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <Select
                                            className="w-100"
                                            showSearch
                                            placeholder="Seleccionar"
                                            filterOption={(input, option) => ((option?.label ?? '').toLowerCase().includes(input.toLowerCase()))}
                                            options={
                                                casos.resources.tramites
                                                    .filter(tr => tr.area_id === formik.values.area_id)
                                                    .map(t => ({ label: `${t.nombre}`, value: t.id }))
                                            }
                                            value={formik.values.tramite_id}
                                            onChange={(value) => formik.setFieldValue('tramite_id', value)}
                                        ></Select>
                                        <ErrorMessage name="tramite_id" component={FormError} />
                                    </div>

                                    <div className="mb-2">
                                        <label htmlFor="monto_adeudado_tramites" className="form-label">
                                            Monto Adeudado Trámites en Bs.
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <Field id="monto_adeudado_tramites" name="monto_adeudado_tramites" type="text" className="form-control form-control-sm" />
                                        <ErrorMessage name="monto_adeudado_tramites" component={FormError} />
                                    </div>

                                    <div className="mb-2">
                                        <label htmlFor="monto_adeudado_honorarios" className="form-label">
                                            Monto Adeudado Honorarios en Bs.
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <Field id="monto_adeudado_honorarios" name="monto_adeudado_honorarios" type="text" className="form-control form-control-sm" />
                                        <ErrorMessage name="monto_adeudado_honorarios" component={FormError} />
                                    </div>

                                    <div className="mb-2">
                                        <label htmlFor="monto_cancelado" className="form-label">
                                            Monto pagado en Bs.
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <Field id="monto_cancelado" name="monto_cancelado" type="text" className="form-control form-control-sm" />
                                        <ErrorMessage name="monto_cancelado" component={FormError} />
                                    </div>

                                    <div className="mb-2 d-flex justify-content-between">
                                        <div>
                                            <span className="text-danger">(*) </span>
                                            <u>Campo obligatorio.</u>
                                        </div>
                                        <button type="submit" className="btn btn-sm btn-light border border-secondary px-4">
                                            {
                                                (casos.loading) ? (
                                                    <Spin size="small" />
                                                ) : "Guardar"
                                            }
                                        </button>
                                    </div>
                                </Form>
                            )
                        }
                    </Formik>
                </div>
                <div className="col-md border-start">
                    <div className="mb-3">
                        <p className="h4">Estado del caso</p>
                    </div>
                    <div className="p-2">
                        <Timeline
                            items={casos.editItem.pasos.map(ps => {
                                if(ps.estado === 'REALIZADO') {
                                    return {
                                        children: (<span className="fw-bold">{ps.descripcion}. (REALIZADO)</span>),
                                        color: 'green',
                                        dot: (<CheckCircleOutlined style={{ fontSize: '18px' }} />)
                                    };
                                }
                                return {
                                    children: ps.descripcion,
                                    color: 'gray'
                                };

                            })}
                        />
                    </div>
                </div>
            </div>

        </div>
    );
}
